import React, { useCallback, useEffect, useState } from 'react';
import { CheckCircle, X } from 'lucide-react';
const buyers = [{
  name: 'Mariana G.',
  city: 'Buenos Aires'
}, {
  name: 'Valentina R.',
  city: 'Rosario'
}, {
  name: 'Camila S.',
  city: 'Córdoba'
}, {
  name: 'Lucía M.',
  city: 'Mendoza'
}, {
  name: 'Florencia D.',
  city: 'La Plata'
}, {
  name: 'Sofía L.',
  city: 'Tucumán'
}, {
  name: 'Carolina P.',
  city: 'Mar del Plata'
}, {
  name: 'Agustina B.',
  city: 'Salta'
}, {
  name: 'Milagros T.',
  city: 'Santa Fe'
}, {
  name: 'Julieta A.',
  city: 'Neuquén'
}, {
  name: 'Rocío H.',
  city: 'San Juan'
}, {
  name: 'Aldana F.',
  city: 'Bahía Blanca'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIdx, setCurrentIdx] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const showNext = useCallback(() => {
    if (dismissed) return;
    setCurrentIdx(prev => (prev + 1) % buyers.length);
    setVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setVisible(false);
    }, 4000);
  }, [dismissed]);
  useEffect(() => {
    // First popup after 5 seconds
    const initialTimer = setTimeout(() => {
      showNext();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, [showNext]);
  useEffect(() => {
    if (!visible && !dismissed && currentIdx > 0) {
      // Show next popup 8-12 seconds after the previous one hides
      const delay = 8000 + Math.random() * 4000;
      const timer = setTimeout(showNext, delay);
      return () => clearTimeout(timer);
    }
  }, [visible, dismissed, currentIdx, showNext]);
  // Also trigger recurring cycle after first show
  useEffect(() => {
    if (!visible && !dismissed && currentIdx === 0) {
      // After initial show+hide, start the cycle
    }
  }, [visible, dismissed, currentIdx]);
  if (dismissed) return null;
  const buyer = buyers[currentIdx];
  const timeAgo = Math.floor(Math.random() * 10) + 1;
  return <div className={`fixed bottom-4 left-4 z-40 max-w-xs transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0 pointer-events-none'}`} data-id="element-233">
      <div className="bg-white rounded-2xl shadow-2xl border border-chocolate-800/10 p-4 flex items-start gap-3" data-id="element-234">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-solution/10 flex items-center justify-center" data-id="element-235">
          <CheckCircle className="w-5 h-5 text-solution" data-id="element-236" />
        </div>
        <div className="flex-grow min-w-0" data-id="element-237">
          <p className="text-sm font-bold text-chocolate-900 leading-snug" data-id="element-238">
            {buyer.name} de {buyer.city}
          </p>
          <p className="text-sm text-chocolate-800/80 leading-snug" data-id="element-239">
            compró{' '}
            <span className="font-bold text-gold-600" data-id="element-240">
              MÉTODO ANTÍDOTO DULCE
            </span>
          </p>
          <p className="text-xs text-chocolate-800/50 mt-1" data-id="element-241">
            hace {timeAgo} {timeAgo === 1 ? 'minuto' : 'minutos'}
          </p>
        </div>
        <button onClick={() => setDismissed(true)} className="flex-shrink-0 text-chocolate-800/30 hover:text-chocolate-800/60 transition-colors" aria-label="Cerrar" data-id="element-242">
          <X className="w-4 h-4" data-id="element-243" />
        </button>
      </div>
    </div>;
}